import cn from 'classnames';
import moment from 'moment';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import ImageViewer from 'react-simple-image-viewer';
import default_image from '../../../../assets/media/icons/products.png';
import { Column, Row, WhiteBlock } from '../../../../components/Basic/Blocks/index.js';
import { AnimateArrow, Button, ButtonWithTooltip, CheckButton } from '../../../../components/Basic/Buttons/index.js';
import { DropDown, NavLink } from '../../../../components/Basic/Elements/index.js';
import { Select } from '../../../../components/Basic/Inputs/index.js';
import { TableCell, TableLine } from '../../../../components/Basic/Table/index.js';
import { Text, TextGrey, Tooltip } from '../../../../components/Basic/WrapsStyle/index.js';
import PenaltyPopUp from '../../../../components/Shipments/Blocks/PenaltyPopUp/index.js';
import PostingStatusWrap from '../../../../components/Shipments/WrapStyle/PostingStatus/index.js';
import ReasonTypeWrap from '../../../../components/Shipments/WrapStyle/ReasonType/index.js';
import { ANSWERS_WAREHOUSE, TO_POSING, TO_SHIPMENT, TYPE_BUTTONS } from '../../../../constans/index.js';
import { formFullDate, formFullDateWithSeconds, getDateMonth, getDateSolid } from '../../../../utils/index.js';
import CommentPostingProductBlock from '../../../Shipments/Posting/CommentBlock/index.js';
import WarehouseHistoryBlock from '../../../Warehouse/WarehouseProducts/ProductHistory/Content/index.js';
import { WIDTH_POSTING } from '../index.js';
import styles from './styles.module.scss';

const ShipmentLine = ({
  MODES,
  FILTER,
  tab,
  shipmentMode = true,
  order = {},
  shipment = {},
  map = {},
  isAdmin = false,
  productsSelect = {},

  changeProductsSelect = (_) => _,
  printSticker = (_) => _,
  changePrintStatus = (_) => _,
  setOpenChzn = () => { },
  isMany = false,
  isDisabledPrint = () => { },
  onChangeProduct = () => { },
  type = 'Отгрузка',
  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [isOpenHistory, setIsOpenHistory] = useState({ state: false, product: null });

  const [images, setImages] = useState([]);

  const [info, setInfo] = useState(false);
  const dispatch = useDispatch();

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  const scan_time_order = order.scan_time?.pick ? formFullDateWithSeconds(order.scan_time.pick) : null;
  const second_scan_time_order = order.scan_time?.packager ? formFullDateWithSeconds(order.scan_time.packager) : null;
  const sort_scan_time_order = order.scan_time?.sort ? formFullDateWithSeconds(order.scan_time.sort) : null;

  return (
    <>
      <TableLine key={order.market_order_number}>
        <TableCell width={WIDTH_POSTING[9]}>
          <CheckButton
            checked={productsSelect[order.posting_number]}
            onSelect={() => changeProductsSelect(order.posting_number)}
          />
        </TableCell>
        <TableCell width={WIDTH_POSTING[0]}>
          {isAdmin ? (
            <Link to={TO_POSING(order.posting_number)} className={styles.link} target="_blank">
              {order.posting_number}
            </Link>
          ) : (
            <>{order.posting_number} </>
          )}{' '}
          {order.market === 'wb' && <span className={styles.wb_sticker}>{order.sticker_parts?.second}</span>} <br />
          <Row style={{ width: '100%' }}>
            {isMany && (
              <NavLink
                to={TO_SHIPMENT(order.shipmentId)}
                target={'_blank'}
                className={styles.scan_time}
                style={{ fontSize: '16px', width: 'auto', marginRight: '5px' }}
              >
                {getDateMonth(order.dates.shipment_date)}
              </NavLink>
            )}
            {order.market === 'wb' && (
              <TextGrey style={{ fontSize: '13px', color: '#6c11c9' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'yandex' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(193 61 0)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'ozon' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(19,79,231)' }}>{order.shop}</TextGrey>
            )}
            {order.market === 'megamarket' && (
              <TextGrey style={{ fontSize: '13px', color: 'rgb(13,131,25)' }}>{order.shop}</TextGrey>
            )}
          </Row>
          <div className={styles.scan_time} onMouseOver={() => setInfo(true)} onMouseLeave={() => setInfo(false)}>
            {scan_time_order} <br />
            {info && (
              <DropDown styles={styles.all_info} close={() => setInfo(false)}>
                <WhiteBlock styles={styles.init}>
                  <TextGrey style={{ marginBottom: '4px' }}>Пропик:</TextGrey>
                  <Text fontSize={18} fontWeight={600}>{`${order.scan_user.pick}`}</Text>
                  <div className={styles.scan_time}>({scan_time_order})</div>
                  {second_scan_time_order && (
                    <>
                      <TextGrey style={{ marginTop: '15px', marginBottom: '4px' }}>Упаковка:</TextGrey>
                      <Text fontSize={18} fontWeight={600}>{`${order.scan_user.packager}`}</Text>
                      <div className={styles.scan_time}>
                        ({second_scan_time_order}){' '}
                        {order.scan_id.packager && (
                          <span>
                            {' '}
                            - сканер id: <span style={{ fontWeight: '600' }}>{order.scan_id.packager}</span>{' '}
                          </span>
                        )}
                      </div>
                    </>
                  )}

                  {sort_scan_time_order && (
                    <>
                      <TextGrey style={{ marginTop: '15px', marginBottom: '4px' }}>Сортировка:</TextGrey>
                      <Text fontSize={18} fontWeight={600}>{`${order.scan_user.sort}`}</Text>
                      <div className={styles.scan_time}>
                        ({sort_scan_time_order}){' '}
                        {order.scan_id.sort && (
                          <span>
                            {' '}
                            - сканер id: <span style={{ fontWeight: '600' }}>{order.scan_id.sort}</span>{' '}
                          </span>
                        )}
                      </div>
                    </>
                  )}
                </WhiteBlock>
              </DropDown>
            )}
          </div>
        </TableCell>
        <TableCell width={WIDTH_POSTING[6]} center>
          <NavLink
            to={TO_SHIPMENT(order.shipment_id)}
            target={'_blank'}
            className={styles.scan_time}
            style={{ fontSize: '18px' }}
          >
            {getDateMonth(order.dates.shipment_date)}
          </NavLink>
        </TableCell>
        <TableCell width={WIDTH_POSTING[1]}>
          <Column>
            {order.products.map((p, k) => {
              const data = map[p.offer_id] || {};
              const img = data.images ? (data.images.length > 0 ? data.images : [default_image]) : [default_image];
              const scan_time = p.scan_time ? formFullDate(p.scan_time) : null;
              return (
                <Column key={`${order.posting_number}-${p.offer_id}-1`}>
                  <div key={k} className={styles.div_line_images}>
                    <div className={styles.wrapper}>
                      <img
                        onClick={() => openImageViewer(img)}
                        className={styles.preview}
                        src={img.length > 0 ? img[0] : undefined}
                      />
                    </div>
                    <Column>
                      <div className={styles.name}>
                        {`${p.ordered_quantity} x ${p.name}  `}
                        <div className={cn(styles.offer_id, p.status === 'Нет в наличии' && styles.red_text)}>
                          {p.offer_id}
                        </div>
                      </div>
                      {scan_time && (
                        <div className={styles.scan_time}>
                          {scan_time} {p.scan_user && `(${p.scan_user})`}
                        </div>
                      )}
                    </Column>
                    <CommentPostingProductBlock
                      isSmall={true}
                      posting={order}
                      offer_id={p.offer_id}
                      onChange={(v) => onChangeProduct(order.posting_number, p._id, 'comment', v)}
                      width="158px"
                    />
                  </div>
                </Column>
              );
            })}
          </Column>
        </TableCell>

        {tab === 'Проверки остатка' && (
          <>
            <TableCell width={WIDTH_POSTING[4]}>
              <Column>
                {order.products.map((p, k) => {
                  const data = map[p.offer_id] || {};
                  return (
                    <Row key={`${order.posting_number}-${p.offer_id}-13`} className={styles.div_line} center={true}>
                      {(p['diff'].comment || '').length > 0 ? (
                        <>
                          <Tooltip text={p['diff'].comment}>
                            {p.diff.status}{' '}
                            {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`} *
                          </Tooltip>
                        </>
                      ) : (
                        <>
                          {p['diff'].status}{' '}
                          {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`}
                        </>
                      )}
                      <ButtonWithTooltip
                        tooltip={isOpenHistory ? 'Скрыть историю изменений' : 'Показать историю изменений'}
                        onClick={() => setIsOpenHistory({ state: !isOpenHistory.state, product: p })}
                      >
                        <AnimateArrow isOpen={isOpenHistory.state} styles={cn(styles.open_icon_arrow)} />
                      </ButtonWithTooltip>
                    </Row>
                  );
                })}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[6]}>
              <Column>
                {order.products.map((p, k) => {
                  return (
                    <Row key={`${order.posting_number}-${p.offer_id}-13`} className={styles.div_line} center={true}>
                      <Text fontWeight={600} fontSize={20}>
                        {p.entried_quantity}
                      </Text>
                    </Row>
                  );
                })}
              </Column>
            </TableCell>
          </>
        )}

        <TableCell width={WIDTH_POSTING[4]}>
          <Column style={{ alignItems: 'center' }}>
            {order.checkups
              .filter((type) => type.category === 'Отгрузка')
              .map((p, k) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={`${order.posting_number}-${p._id}-12`} className={styles.div_line}>
                  <ReasonTypeWrap reason={p.reason.type} />
                </div>
              ))}
          </Column>
        </TableCell>
        <TableCell center={true} width={WIDTH_POSTING[5]}>
          <Column style={{ alignItems: 'center' }}>
            {order.products.map((p, k) => (
              <div key={`${order.posting_number}-${p.offer_id}-14`} style={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }} className={styles.div_line}>
                <div >
                  {p.arrived_date ? moment(getDateSolid(p.arrived_date)).format('DD.MM.YYYY') : '-'}
                </div>
                <div style={{ fontSize: '12px', color: '#3e3e3e86' }}>
                  {p.dokup.date ? moment(getDateSolid(p.dokup.date)).format('DD.MM.YYYY') : ''}
                </div>
              </div>
            ))}
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[3]}>
          <Column>
            {order.checkups
              .filter((type) => type.category === 'Отгрузка')
              .map((p, k) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={`${order.posting_number}-${p._id}-13`} className={styles.div_line}>
                  <Text>{p.reason.comment}</Text>
                </div>
              ))}
          </Column>
        </TableCell>

        <TableCell width={WIDTH_POSTING[11]}>
          <Column>
            {order.checkups
              .filter((type) => type.category === 'Отгрузка')
              .map((p) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={`${order.posting_number}-${p._id}-14`} className={styles.div_line}>
                  <Select
                    select={p.response.msg}
                    list={ANSWERS_WAREHOUSE}
                    onSelect={(v) =>
                      onChangeProduct(order.posting_number, p._id, 'checkup_response_msg', v === 'Нет' ? undefined : v)
                    }
                    width={'230px'}
                  />
                </div>
              ))}
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[11]}>
          <Column>
            {order.checkups
              .filter((type) => type.category === 'Отгрузка')
              .map((p, k) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={`${order.posting_number}-${p._id}-14`} className={styles.div_line}>
                  <CommentPostingProductBlock
                    posting={order}
                    offer_id={p._id}
                    onChange={(v) => onChangeProduct(order.posting_number, p._id, 'comment_checkup', v)}
                    width={'230px'}
                  />
                </div>
              ))}
          </Column>
        </TableCell>

        <TableCell width={WIDTH_POSTING[3]} center={true}>
          <PostingStatusWrap order={order} />
        </TableCell>
        {isAdmin && (
          <TableCell width={WIDTH_POSTING[3]} center={true}>
            <Column>
              {order.checkups
                .filter((type) => type.category === 'Отгрузка')
                .map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={`${order.posting_number}-${p._id}-14`} className={styles.div_line}>
                    <Button
                      type={TYPE_BUTTONS.GREEN}
                      style={{ marginRight: '15px' }}
                      onClick={() => onChangeProduct(order.posting_number, p._id, 'checkup_is_closed', true)}
                      disabled={p.result.is_closed}
                    >
                      Решено
                    </Button>
                    <PenaltyPopUp
                      disabled={p.result.is_closed}
                      checkup={p}
                      order={order}
                      onChangeProduct={(data) => onChangeProduct(order.posting_number, p._id, 'penalty', data)}
                    />
                  </div>
                ))}
            </Column>
          </TableCell>
        )}

        {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
      </TableLine>
      {isOpenHistory.state && (
        !isOpenHistory.product.history ? 
        <div className={styles.history_block}>Истории по товару не существует</div> :
        <div className={styles.history_block}>
          {isOpenHistory.product.history.map((item) => (
            <WarehouseHistoryBlock part={item} key={item['_id']} />
          ))}
        </div>
      )}
    </>
  );
};

export default ShipmentLine;
